import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { IAM_API_BASE_URL_2, IAM_SUBASSEMBLY_URL } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from '../../../components/ui/TapSelect';
import moment from 'moment';
import DatePicker from "react-datepicker";
import TapIcon from '../../../services/TapIcon';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import DateService from '../../../services/DateService';
import CounterlogModal from '../../assets/counterlog/CounterlogModal';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';

class LinkingModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        
        this.linkAssetFormInit               =   {
            sub_assembly_id                  :       "",
            counterlog_transaction_id       :       '',
            date_time                    :       '',
            linked_hour_meter            :       '',
            linked_odo_meter             :       '',
            linked_opc                   :       ''
         };  

         this.initState         =       {
            access_token                :   '',
            transaction_id              :   '',
            date                        :   '',
            assetDetail                 :   null,
            linkAssetForm                   :   {...this.linkAssetFormInit},
            linkedAsset                     :   null,
            assetDetail                     :   null,
            proceedForm                     :   false,
            enable_hour_meter               :   'N',
            enable_odo_meter               :   'N',
            enable_opc                     :   'N',
            currentActionType               :   'link',
            selectedRosterDetail            :   null,
            roster_loading                  :   false,
            selectedSubAssemblyDetail       :   null,
            site_id                         :    '',
            fromSubAssembly                 :    'Y',
            hourMeterPresent                :     false,
            odoMeterPresent                 :     false,
            operationCyclePresent           :     false,
            hourMeterList                   :      [],
            odoMeterList                   :       [],
            operationCycleList             :       [],
            // Bulk properties
            isBulkMode                      :      false,
            selectedSubAssemblies           :      [],
            subAssemblyList                 :      [],
            bulkActionType                  :      'link',
            bulkSiteId                      :      '',
            bulkAssetId                     :      '',
            // Bulk Sub Assembly display
            bulkSubAssemblyDisplay          :      '',
            bulkSubAssemblyCount            :      0
         }

        this.state                  =   {
            ...this.initState
        }
        this.linkAssetModalId   =   uuid();
        this.CounterLogModalRef         =       React.createRef(); 
        this.linkAssetModalFormId    =   this.linkAssetModalId + 'Form';
    }

    componentDidMount                   =   ()  =>  {
        this.initScreen(this.props);
        this.linkAssetModal         =   new Modal(document.getElementById(this.linkAssetModalId), {keyboard: false, backdrop :false});  
        
        
    }
    
    componentWillReceiveProps(nextProps) {
         this.initScreen(nextProps);
    }
    
    initScreen                          =   (props)  =>  {
        this.setState({access_token : props.access_token});
    }

    // Reset modal state completely
    resetModalState = () => {
        this.setState({
            ...this.initState,
            access_token: this.state.access_token,
            isBulkMode: false,
            selectedSubAssemblies: [],
            subAssemblyList: [],
            bulkActionType: 'link',
            bulkSiteId: '',
            bulkAssetId: '',
            bulkSubAssemblyDisplay: '',
            bulkSubAssemblyCount: 0,
            linkAssetForm: {...this.linkAssetFormInit},
            linkedAsset: null,
            assetDetail: null,
            proceedForm: false,
            enable_hour_meter: 'N',
            enable_odo_meter: 'N',
            enable_opc: 'N',
            selectedRosterDetail: null,
            roster_loading: false,
            selectedSubAssemblyDetail: null,
            hourMeterPresent: false,
            odoMeterPresent: false,
            operationCyclePresent: false,
            hourMeterList: [],
            odoMeterList: [],
            operationCycleList: [],
            saveFormSubmitting: false,
            asset_loading: false
        });
    };

    // New method for bulk linking modal initialization
    linkBulkAssetModalInit = (selectedSubAssemblies = [], subAssemblyList = [], actionType = 'link', siteId = '') => {
        // First reset the modal
        this.resetModalState();
        
        // Validate selections based on action type
        if (selectedSubAssemblies.length === 0) {
            toast.error("Please select at least one Sub Assembly", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        // Get selected items with full data
        const selectedItems = subAssemblyList.filter(item => 
            selectedSubAssemblies.includes(item.enc_id)
        );

        if (selectedItems.length === 0) {
            toast.error("Selected Sub Assemblies not found", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        // Check if all selected sub assemblies are from same site
        const uniqueSiteIds = [...new Set(selectedItems.map(item => item.site?.id).filter(id => id))];
        if (uniqueSiteIds.length > 1) {
            toast.error("You cannot select Sub Assemblies from different Sites. Please select from the same site.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        // Generate display text for bulk sub assemblies
        const displayNames = selectedItems.slice(0, 3).map(item => 
            item.name || item.card_number || 'Unknown'
        ).join(', ');
        const remainingCount = selectedItems.length - 3;
        const displayText = remainingCount > 0 
            ? `${displayNames} +${remainingCount} more`
            : displayNames;

        // Validate based on action type
        if (actionType === "link") {
            // Check if any selected sub assembly is already linked
            const alreadyLinked = selectedItems.filter((item) => item.asset_profile);
            if (alreadyLinked.length > 0) {
                toast.error(
                    `${alreadyLinked.length} selected Sub Assembly(ies) are already linked with an Asset. Please select only unlinked sub assemblies for linking.`,
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }

            const siteId = selectedItems.length > 0 && selectedItems[0].site ? selectedItems[0].site.id : '';
            
            // Store site ID for asset search
            this.setState({
                bulkSiteId: siteId,
                selectedSubAssemblies: selectedSubAssemblies,
                subAssemblyList: subAssemblyList,
                bulkActionType: actionType,
                isBulkMode: true,
                currentActionType: actionType,
                selectedSubAssemblyDetail: null,
                bulkSubAssemblyDisplay: displayText,
                bulkSubAssemblyCount: selectedItems.length,
                linkAssetForm: {
                    ...this.linkAssetFormInit,
                    sub_assembly_id: selectedSubAssemblies[0] // Store first ID as reference
                },
                proceedForm: true // Show proceed button first
            }, () => {
                this.linkAssetModal.show();
            });

        } else if (actionType === "delink") {
            // Check if any selected sub assembly is NOT linked
            const notLinked = selectedItems.filter((item) => !item.asset_profile);
            if (notLinked.length > 0) {
                toast.error(
                    `${notLinked.length} selected Sub Assembly(ies) are not linked with any Asset. Please select only linked sub assemblies for delinking.`,
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }

            // Check if all selected sub assemblies are linked with same asset
            const assetIds = [...new Set(selectedItems.map((i) => i.asset_profile?.asset_id).filter(id => id))];
            if (assetIds.length > 1) {
                toast.error(
                    "Selected Sub Assemblies are linked with different Assets. Please select sub assemblies linked with the same asset.",
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }

            // Get the common asset
            const commonAsset = selectedItems[0]?.asset_profile;
            
            this.setState({
                selectedSubAssemblies: selectedSubAssemblies,
                subAssemblyList: subAssemblyList,
                bulkActionType: actionType,
                isBulkMode: true,
                currentActionType: actionType,
                bulkSubAssemblyDisplay: displayText,
                bulkSubAssemblyCount: selectedItems.length,
                linkedAsset: commonAsset ? {
                    ...commonAsset,
                    value: commonAsset.asset_id,
                    display_label: `${commonAsset.name}(${commonAsset.asset_code})`
                } : null,
                linkAssetForm: {
                    ...this.linkAssetFormInit,
                    sub_assembly_id: selectedSubAssemblies[0], // Store first ID as reference
                    asset_id: commonAsset?.asset_id || ''
                },
                selectedSubAssemblyDetail: null,
                proceedForm: false // Directly show form for delink
            }, () => {
                this.linkAssetModal.show();
                if (commonAsset) {
                    this.getAssetDetail();
                }
            });
        }
    };

    linkAssetModalInit = (subAssemblyDetail = null, action_type = 'link', asset_id = '', assetDetail = null, fromSubAssembly = 'Y', site_id = '') => {
        // Reset bulk mode and all state
        this.resetModalState();

        this.linkAssetModal.show();
        
        setTimeout(() => {
            let sub_assembly = subAssemblyDetail || null;
            let linkedAssetValue = null;
            let formValues = {
                ...this.linkAssetFormInit,
                sub_assembly_id: sub_assembly && sub_assembly.enc_id || '',
                asset_id: action_type === 'delink' ? asset_id : asset_id ? asset_id : ''
            };
            
            linkedAssetValue = action_type === 'delink' && sub_assembly && sub_assembly.asset_profile ? {
                ...sub_assembly.asset_profile,
                display_label: `${sub_assembly.asset_profile.name}(${sub_assembly.asset_profile.asset_code})`
            } : assetDetail ? {
                ...assetDetail,
                value: assetDetail.asset_id,
                display_label: `${assetDetail.name}(${assetDetail.asset_code})`
            } : null;
            
            this.setState({
                linkAssetForm: formValues,
                linkedAsset: linkedAssetValue,
                assetDetail: null,
                proceedForm: action_type === 'link',
                enable_hour_meter: 'N',
                enable_odo_meter: 'N',
                enable_opc: 'N',
                site_id: fromSubAssembly == 'Y' ? '' : site_id,
                currentActionType: action_type,
                subAssemblyDetail: subAssemblyDetail,
                fromSubAssembly: fromSubAssembly,
                selectedSubAssemblyDetail: subAssemblyDetail ? {...subAssemblyDetail, value: subAssemblyDetail.enc_id, display_label: subAssemblyDetail.name, label: subAssemblyDetail.name} : null,
                isBulkMode: false,
                selectedSubAssemblies: [],
                subAssemblyList: [],
                bulkSubAssemblyDisplay: '',
                bulkSubAssemblyCount: 0
            }, action_type === 'delink' ? () => this.getAssetDetail() : null);
        }, 100);
    };

    getAssetDetail = () => {
        if (this.state.linkAssetForm && this.state.linkAssetForm.asset_id) {
            this.setState({ asset_loading: true, saveFormSubmitting: true, assetDetail: null });
    
            HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset/' + this.state.linkAssetForm.asset_id, this.props.access_token, {}, {}, (response) => {
                const assetDetail = response.data.data;
    
                let hourMeterPresent = false;
                let odoMeterPresent = false;
                let operationCyclePresent = false;
                let hourMeterList = [];
                let odoMeterList = [];
                let operationCycleList = [];
    
                if (assetDetail && assetDetail.labels) {
                    const checkMeter = (meter) => assetDetail[meter] === "yes";
                    const pushMeterList = (meter, meterLabel, list) => checkMeter(meter) && list.push({ value: meter, label: meterLabel });
    
                    const pushHourMeter = (meter) => {
                        const meterLabel = assetDetail.labels[meter];
                        pushMeterList(meter, meterLabel, hourMeterList);
                    };
    
                    const pushOdoMeter = (meter) => {
                        const meterLabel = assetDetail.labels[meter];
                        pushMeterList(meter, meterLabel, odoMeterList);
                    };
    
                    const pushOperationCycle = (meter) => {
                        const meterLabel = assetDetail.labels[meter];
                        pushMeterList(meter, meterLabel, operationCycleList);
                    };
    
                    hourMeterPresent = checkMeter('hour_meter') || checkMeter('hour_meter2') || checkMeter('hour_meter3') || checkMeter('hour_meter4');
                    odoMeterPresent = checkMeter('odo_meter') || checkMeter('odo_meter2') || checkMeter('odo_meter3');
                    operationCyclePresent = checkMeter('operation_cycle') || checkMeter('operation_cycle2');
    
                    pushHourMeter('hour_meter');
                    pushHourMeter('hour_meter2');
                    pushHourMeter('hour_meter3');
                    pushHourMeter('hour_meter4');
    
                    pushOdoMeter('odo_meter');
                    pushOdoMeter('odo_meter2');
                    pushOdoMeter('odo_meter3');
    
                    pushOperationCycle('operation_cycle');
                    pushOperationCycle('operation_cycle2');
                }
    
                const enableAndSelectSingleMeter = (meterList, enableState, linkedState) => {
                    if (meterList.length === 1) {
                        this.setState({
                            [enableState]: 'Y',
                            linkAssetForm: {
                                ...this.state.linkAssetForm,
                                [linkedState]: meterList[0].value
                            }
                        });
                    }
                };
    
                enableAndSelectSingleMeter(hourMeterList, 'enable_hour_meter', 'linked_hour_meter');
                enableAndSelectSingleMeter(odoMeterList, 'enable_odo_meter', 'linked_odo_meter');
                enableAndSelectSingleMeter(operationCycleList, 'enable_opc', 'linked_opc');
    
                this.setState({ 
                    assetDetail, 
                    hourMeterPresent, 
                    odoMeterPresent, 
                    operationCyclePresent, 
                    hourMeterList, 
                    odoMeterList, 
                    operationCycleList, 
                    proceedForm: false 
                });
            }, (error) => {
                toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
            }).then(() => {
                this.setState({ asset_loading: false, saveFormSubmitting: false });
            });
        } else {
            toast.error("Please select Asset First", { position: toast.POSITION.TOP_RIGHT });
        }
    };
    
    handleInputChange = (name, value) => {
        this.setState({
            linkAssetForm: { ...this.state.linkAssetForm, [name]: value }
        });
    };

    getShiftListing = (date_time) => {
        this.setState({ roster_loading: true });
        let params = {
            date_range_start: date_time,
            date_range_end: date_time 
        };
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/v2/monthly_logsheet/' + this.state?.assetDetail?.asset_id, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                selectedRosterDetail: respData.data,
                shifts: respData.shifts,
                asset_meter: respData.asset_meter,
            });
        }).then(() => this.setState({ roster_loading: false }));
    }

    updateCounterlogModalInit = (shiftData, date) => {
        this.CounterLogModalRef.current.updateCounterlogInit(shiftData, date, this.state.linkedAsset ? this.state.linkedAsset : this.state.assetDetail ? this.state.assetDetail : "");
    }
    
    afterUpdateCounterlogSubmit = (date, asset_id, refresh_asset_card = true) => {
        let itemList = [...this.state.selectedRosterDetail];
        let dateIndex = itemList.findIndex(i => i.date == date);
        itemList[dateIndex] = {...this.state.selectedRosterDetail[dateIndex], isLoading: true};
        this.setState({ selectedRosterDetail: itemList });
    
        let params = { page: null, date_range_start: date, date_range_end: date };
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/counterlog/v2/monthly_logsheet/' + this.state.linkAssetForm.asset_id, this.props.access_token, params, {}, (resp) => {
            if(resp.data && resp.data.data) {
                itemList[dateIndex] = resp.data.data[0];
                this.setState({ selectedRosterDetail: itemList });
            }
        });
    }

    // Modified submit method to handle bulk operations
    submitLinkAssetForm = (e) => {
        e.preventDefault();
        
        const { isBulkMode, selectedSubAssemblies, bulkActionType } = this.state;
        
        if (isBulkMode) {
            this.handleBulkSubmit();
        } else {
            this.handleSingleSubmit();
        }
    };

    handleSingleSubmit = () => {
    if (this.state.currentActionType == 'link') {
        this.setState({ saveFormSubmitting: true });
        const id = this.state.linkAssetForm.sub_assembly_id;
        const { linked_hour_meter, linked_odo_meter, linked_opc } = this.state.linkAssetForm;
        const link_meters = [linked_hour_meter, linked_odo_meter, linked_opc];
        const data = {
            ...this.state.linkAssetForm,
            sub_assembly_id: this.state.linkAssetForm.sub_assembly_id,
            asset_id: this.state.linkAssetForm.asset_id,
            date_time: DateService.dateTimeFormat(this.state.linkAssetForm.date_time, 'YYYY-MM-DD HH:mm:ss'),
            link_meters: link_meters.filter(meter => meter ? true : false)
        }; 
        
        HttpAPICall.withAthorization('POST', IAM_SUBASSEMBLY_URL + '/asset/link', this.props.access_token, null, data, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.props.afterSubmitForm(id, 'minimize');
            this.linkAssetModal.hide();
            this.resetModalState();
            this.setState({ saveFormSubmitting: false });
        }, (error) => {
            const errorMessage = error?.response?.data?.message || error?.msg || "Link operation failed";
            toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT });
            this.linkAssetModal.hide();
            this.setState({ saveFormSubmitting: false });
        }).catch((error) => {
            toast.error(error?.message || "Link operation failed", { position: toast.POSITION.TOP_RIGHT });
            this.linkAssetModal.hide();
            this.setState({ saveFormSubmitting: false });
        });
        
    } else {
        this.setState({ saveFormSubmitting: true });
        const id = this.state.linkAssetForm.sub_assembly_id;
        const { linked_hour_meter, linked_odo_meter, linked_opc } = this.state.linkAssetForm;
        const link_meters = [linked_hour_meter, linked_odo_meter, linked_opc];
        const data = {
            ...this.state.linkAssetForm,
            sub_assembly_id: this.state.linkAssetForm.sub_assembly_id,
            asset_id: this.state.linkAssetForm.asset_id,
            date_time: DateService.dateTimeFormat(this.state.linkAssetForm.date_time, 'YYYY-MM-DD HH:mm:ss'),
            link_meters: link_meters.filter(meter => meter ? true : false)
        }; 
        
        HttpAPICall.withAthorization('POST', IAM_SUBASSEMBLY_URL + '/asset/delink', this.props.access_token, null, data, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.props.afterSubmitForm(id, 'minimize');
            this.linkAssetModal.hide();
            this.resetModalState();
            this.setState({ saveFormSubmitting: false });
        }, (error) => {
            const errorMessage = error?.response?.data?.message || error?.msg || "Delink operation failed";
            toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT });
            this.linkAssetModal.hide();
            this.setState({ saveFormSubmitting: false });
        }).catch((error) => {
            toast.error(error?.message || "Delink operation failed", { position: toast.POSITION.TOP_RIGHT });
            this.linkAssetModal.hide();
            this.setState({ saveFormSubmitting: false });
        });
    }
};

    handleBulkSubmit = () => {
    const { selectedSubAssemblies, bulkActionType, linkAssetForm, assetDetail } = this.state;
    
    if (selectedSubAssemblies.length === 0) {
        toast.error("No sub assemblies selected", { position: toast.POSITION.TOP_RIGHT });
        return;
    }

    this.setState({ saveFormSubmitting: true });

    const data = {
        ids: selectedSubAssemblies,
        asset_id: linkAssetForm.asset_id,
        date_time: DateService.dateTimeFormat(linkAssetForm.date_time, 'YYYY-MM-DD HH:mm:ss'),
        counterlog_transaction_id: linkAssetForm.counterlog_transaction_id || ''
    };
        const { linked_hour_meter, linked_odo_meter, linked_opc } = linkAssetForm;
        const link_meters = [linked_hour_meter, linked_odo_meter, linked_opc].filter(meter => meter ? true : false);
        data.link_meters = link_meters;
    

    const endpoint = bulkActionType === 'link' 
        ? IAM_API_BASE_URL_2 + '/multiple_sub_assembly/asset/link'
        : IAM_API_BASE_URL_2 + '/multiple_sub_assembly/asset/delink';

    HttpAPICall.withAthorization('POST', endpoint, this.props.access_token, null, data, (response) => {
        toast.success(response.data.msg || `${bulkActionType === 'link' ? 'Linked' : 'Delinked'} successfully for selected sub assemblies`, {
            position: toast.POSITION.TOP_RIGHT
        });
        
        // Reset bulk state
        this.resetModalState();
        
        // Refresh parent
         if (this.props.afterSubmitForm) {
            this.props.afterSubmitForm(null, 'bulk');
        }
        
        // Hide modal and stop loader
        this.linkAssetModal.hide();
        this.setState({ saveFormSubmitting: false });
        
    }, (error) => {
        // Handle error
        const errorMessage = error?.response?.data?.message || error?.msg || "Operation failed";
        toast.error(errorMessage, {
            position: toast.POSITION.TOP_RIGHT
        });
        
        // Hide modal and stop loader on error
        this.linkAssetModal.hide();
        this.setState({ saveFormSubmitting: false });
        
    }).catch((error) => {
        // Catch any unhandled errors
        const errorMessage = error?.response?.data?.message || error?.message || "Operation failed";
        toast.error(errorMessage, {
            position: toast.POSITION.TOP_RIGHT
        });
        
        // Hide modal and stop loader
        this.linkAssetModal.hide();
        this.setState({ saveFormSubmitting: false });
    });
};

    // Helper method to render bulk info with "X more" display
  

    // Handle asset change - clear all related data
    handleAssetChange = (selectedOption) => {
        // Reset all asset-related data
        this.setState({
            linkedAsset: selectedOption ? { ...selectedOption, ...selectedOption.asset } : null,
            assetDetail: null,
            selectedRosterDetail: null,
            shifts: null,
            asset_meter: null,
            hourMeterPresent: false,
            odoMeterPresent: false,
            operationCyclePresent: false,
            hourMeterList: [],
            odoMeterList: [],
            operationCycleList: [],
            linkAssetForm: {
                ...this.state.linkAssetForm,
                asset_id: selectedOption ? selectedOption.value : '',
                date_time: '',
                counterlog_transaction_id: '',
                linked_hour_meter: '',
                linked_odo_meter: '',
                linked_opc: ''
            },
            enable_hour_meter: 'N',
            enable_odo_meter: 'N',
            enable_opc: 'N'
        }, () => {
            // If asset is selected, get its details
            if (selectedOption && this.state.proceedForm == false) {
                this.getAssetDetail();
            }
        });
    };
renderSubAssemblyeNames = () => {
    const { isBulkMode, selectedSubAssemblies, subAssemblyList, bulkSubAssemblyDisplay, bulkSubAssemblyCount } = this.state;
    
    if (!isBulkMode) return "-";
    
    if (selectedSubAssemblies.length === 0) return "-";
    
    if (bulkSubAssemblyDisplay) {
        return bulkSubAssemblyDisplay;
    }
    
    const selectedItems = subAssemblyList.filter(
        item => selectedSubAssemblies.includes(item.enc_id)
    );

    if (selectedItems.length === 0) return "-";

    const firstTwoNames = selectedItems.slice(0, 2).map(item =>
        item.name || item.card_number || 'Unknown'
    ).join(', ');

    const remainingCount = selectedItems.length - 2;

    if (remainingCount > 0) {
        return `${firstTwoNames} +${remainingCount} more`;
    }

    return firstTwoNames;
};
    linkAssetModalJsx = () => {
        let { hourMeterPresent, odoMeterPresent, operationCyclePresent, hourMeterList, odoMeterList, operationCycleList, assetDetail, isBulkMode } = this.state;
        
        return (
            <div className="modal fade" id={this.linkAssetModalId} tabIndex="-1" data-bs-backdrop="static">
                <div className={'modal-dialog modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="changeSiteModalLabel">
                                {isBulkMode 
                                    ? `${this.state.bulkActionType == "link" ? "Bulk Link" : "Bulk De-Link"} Sub Assemblies`
                                    : `${this.state.currentActionType == "link" ? "Link" : "De - Link"} Sub Assembly`
                                }
                            </h5>
                            <button 
                                type="button" 
                                className="btn-close" 
                                data-bs-dismiss="modal" 
                                aria-label="Close"
                                onClick={() => this.resetModalState()}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={this.submitLinkAssetForm} id={this.linkAssetModalFormId}>
                                {/* Bulk Info */}
                                 {isBulkMode &&
                                 <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Selected Sub Assemblies
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                disabled={true}
                                                value={this.renderSubAssemblyeNames()}
                                            />
                                        </div>
                                    </div>}
                               

                                {/* Sub Assembly - Hidden in bulk mode */}
                                {!isBulkMode && (
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Sub Assembly</label>
                                        <div className="col-sm-9">
                                            <InputSubAssemblySearch
                                                required={true}
                                                placeholder="Search Sub Assembly"
                                                changeEvent={(selectedOption) => {
                                                    this.tapSelectChange(selectedOption, 'linkAssetForm', 'sub_assembly_id', () => {});
                                                    this.setState({
                                                        selectedSubAssemblyDetail: selectedOption ? selectedOption : null
                                                    }, () => {});
                                                }}
                                                disabled={this.state.fromSubAssembly == 'Y' ? true : false}
                                                search_site_id={this.state.site_id}
                                                search_is_linked="N"
                                                value={this.state.selectedSubAssemblyDetail ? { ...this.state.selectedSubAssemblyDetail, label: this.state.selectedSubAssemblyDetail.display_label } : null}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Asset */}
                                <div className="row mb-3">
                                    <label className="col-sm-3 col-form-label col-form-label-sm">Asset</label>
                                    <div className="col-sm-9">
                                        <InputAssetSearch
                                            required={true}
                                            placeholder="Search Asset"
                                            changeEvent={(selectedOption) => {
                                                this.handleAssetChange(selectedOption);
                                            }}
                                            disabled={this.state.currentActionType == 'delink' || (this.state.fromSubAssembly == 'N' && !isBulkMode) ? true : false}
                                            search_site_id={isBulkMode ? this.state.bulkSiteId : (this.state.subAssemblyDetail && this.state.subAssemblyDetail.site ? this.state.subAssemblyDetail.site.id : '')}
                                            value={this.state.linkedAsset ? { ...this.state.linkedAsset, label: this.state.linkedAsset.display_label } : null}
                                        />
                                    </div>
                                </div>

                                {assetDetail && (
                                    <Ax>
                                        <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label col-form-label-sm">Date</label>
                                            <div className="col-sm-9 add_calender_section">
                                                <DatePicker
                                                    selected={
                                                        this.state.linkAssetForm.date_time ? moment(this.state.linkAssetForm.date_time, "YYYY-MM-DD").toDate() : false
                                                    }
                                                    name="date_time"
                                                    onChange={(value, event) => { 
                                                        this.formDateHandler("date_time", value, "linkAssetForm", 'YYYY-MM-DD', () => 
                                                            this.getShiftListing(this.state.linkAssetForm.date_time)
                                                        );
                                                    }}
                                                    maxDate={moment(new Date(), "YYYY-MM-DD").toDate()}
                                                    dateFormat="dd-MMM-yyyy"
                                                    className={"form-control form-control-sm"}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    autoComplete="off"
                                                    scrollMonthYearDropdown
                                                    required={true}
                                                    placeholderText={`Please Enter Date`}
                                                />
                                                <TapIcon.imageIcon
                                                    icon={TapIcon.CalenderIcon}
                                                    alt="purchase_date"
                                                    className="add_calender-icon"
                                                />
                                            </div>
                                        </div>

                                        {this.state.linkAssetForm.date_time && (
                                            <div className='counterlog'>
                                                <table className="table table-bordered bg-white table-hover table-sm table-fixed mb-0" id="assetLogsheetTable">
                                                    <thead className='table-secondary text-center'>
                                                        <th style={{ width: "5%" }}></th>
                                                        <th style={{ width: "15%" }}>Date</th>
                                                        <th style={{ width: "25%" }}>Shift</th>
                                                        <th style={{ width: "25%" }}>CounterLog</th>
                                                    </thead>
                                                    <tbody>
                                                        {!this.state.roster_loading ? (
                                                            this.state.selectedRosterDetail && this.state.selectedRosterDetail.length > 0 ? (
                                                                this.state.selectedRosterDetail.map((day, i) => {
                                                                    let shifts = day && day.logsheet && day.logsheet.shifts ? day.logsheet.shifts : [];
                                                                    return (
                                                                        <Ax key={i}>
                                                                            {shifts.map((sf, key) => {
                                                                                let shift = this.state.shifts.find(sh => sh.id == sf.shift_id);
                                                                                return (
                                                                                    <tr className="text-center" key={key}>
                                                                                        <td>
                                                                                            <input
                                                                                                type="radio"
                                                                                                checked={
                                                                                                    sf.transaction_id &&
                                                                                                    this.state.linkAssetForm.counterlog_transaction_id === sf.transaction_id
                                                                                                }
                                                                                                onChange={() =>
                                                                                                    this.setState({
                                                                                                        linkAssetForm: {
                                                                                                            ...this.state.linkAssetForm,
                                                                                                            counterlog_transaction_id: sf.transaction_id,
                                                                                                        },
                                                                                                    })
                                                                                                }
                                                                                                disabled={sf.transaction_id ? false : true}
                                                                                            />
                                                                                        </td>
                                                                                        {key === 0 ? (
                                                                                            <td className="align-middle" rowSpan={day?.logsheet?.shifts?.length}>
                                                                                                {DateService.dateFormat(day.date)}
                                                                                            </td>
                                                                                        ) : null}
                                                                                        <td className="align-middle">
                                                                                            {shift.shift_name} <br /> {shift.shift_start}
                                                                                        </td>
                                                                                        {day.isLoading ? (
                                                                                            <td colSpan={9} className="text-center">
                                                                                                <Loader />
                                                                                            </td>
                                                                                        ) : (
                                                                                            <td className="align-middle">
                                                                                                {sf.cl ? (
                                                                                                    <span className="text-start">
                                                                                                        {sf.cl.length === 1 ? (
                                                                                                            <div className="mt-1 link-primary cursor_pointer text-center">View</div>
                                                                                                        ) : (
                                                                                                            sf.cl
                                                                                                                .filter((c) => c.key != "feed_datetime")
                                                                                                                .map((c, index) => {
                                                                                                                    let meter = this.state.asset_meter.find(m => m.key === c.key);
                                                                                                                    return (
                                                                                                                        <div key={index} className="mt-1 cursor_pointer">
                                                                                                                            {meter && <>{meter.label}</>} : {c.reading} {meter && <>{meter.unit}</>}
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                })
                                                                                                        )}
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <a role="button" className="link-primary" onClick={() => this.updateCounterlogModalInit(sf, day.date)}>
                                                                                                        No Record
                                                                                                    </a>
                                                                                                )}
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </Ax>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td className="text-center" colSpan={4}>No Record</td>
                                                                </tr>
                                                            )
                                                        ) : (
                                                            <tr>
                                                                <td className="text-center" colSpan={4}><Loader /></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {/* Meter selection - only for linking */}
                                        {this.state.currentActionType == "link" && (
                                            <div className='counterlog'>
                                                <div className="tab_content_wrapper">
                                                    <span className="content_heading">Link with Meter</span>
                                                </div>
                                                {hourMeterPresent && (
                                                    <div className="row my-3">
                                                        <div className="col-sm-3">
                                                            <input
                                                                name="enable_hour_meter"
                                                                type="checkbox"
                                                                value={this.state.enable_hour_meter}
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    this.setState({ 
                                                                        enable_hour_meter: isChecked ? 'Y' : 'N',
                                                                        linkAssetForm: { ...this.state.linkAssetForm, linked_hour_meter: isChecked ? '' : null }
                                                                    });
                                                                }}
                                                                checked={this.state.enable_hour_meter == 'Y'}
                                                                className="form-check-input"
                                                                id="enable_hour_meter"
                                                            />
                                                            <label className="form-check-label mx-2" htmlFor="enable_hour_meter">Enable <b>Hour Meter</b></label>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <TapSelect
                                                                options={hourMeterList}
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'linkAssetForm', 'linked_hour_meter');
                                                                }}
                                                                isSearchable={true}
                                                                value={hourMeterList.find(s => this.state.linkAssetForm.linked_hour_meter == s.value)}
                                                                isClearable={true}
                                                                placeholder="Select Hour Meter"
                                                                autoCompelete="off"
                                                                menuPlacement={'top'}
                                                                containerHeight="30px"
                                                                fontSize="93%"
                                                                isDisabled={this.state.enable_hour_meter == 'N'}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                {odoMeterPresent && (
                                                    <div className="row my-3">
                                                        <div className="col-sm-3">
                                                            <input
                                                                name="enable_odo_meter"
                                                                type="checkbox"
                                                                value={this.state.enable_odo_meter}
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    this.setState({ 
                                                                        enable_odo_meter: isChecked ? 'Y' : 'N',
                                                                        linkAssetForm: { ...this.state.linkAssetForm, linked_odo_meter: isChecked ? '' : null }
                                                                    });
                                                                }}
                                                                checked={this.state.enable_odo_meter == 'Y'}
                                                                className="form-check-input"
                                                                id="enable_odo_meter"
                                                            />
                                                            <label className="form-check-label mx-2" htmlFor="enable_odo_meter">Enable <b>Odo Meter</b></label>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <TapSelect
                                                                options={odoMeterList}
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'linkAssetForm', 'linked_odo_meter');
                                                                }}
                                                                isSearchable={true}
                                                                value={odoMeterList.find(s => this.state.linkAssetForm.linked_odo_meter == s.value)}
                                                                isClearable={true}
                                                                placeholder="Select Odo Meter"
                                                                autoCompelete="off"
                                                                menuPlacement={'top'}
                                                                containerHeight="30px"
                                                                fontSize="93%"
                                                                isDisabled={this.state.enable_odo_meter == 'N'}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                {operationCyclePresent && (
                                                    <div className="row my-3">
                                                        <div className="col-sm-3">
                                                            <input
                                                                name="enable_opc"
                                                                type="checkbox"
                                                                value={this.state.enable_opc}
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    this.setState({ 
                                                                        enable_opc: isChecked ? 'Y' : 'N',
                                                                        linkAssetForm: { ...this.state.linkAssetForm, linked_opc: isChecked ? '' : null }
                                                                    });
                                                                }}
                                                                checked={this.state.enable_opc == 'Y'}
                                                                className="form-check-input"
                                                                id="enable_opc"
                                                            />
                                                            <label className="form-check-label mx-2" htmlFor="enable_opc">Enable <b>Op. Cycle</b></label>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <TapSelect
                                                                options={operationCycleList}
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'linkAssetForm', 'linked_opc');
                                                                }}
                                                                isSearchable={true}
                                                                value={operationCycleList.find(s => this.state.linkAssetForm.linked_opc == s.value)}
                                                                isClearable={true}
                                                                placeholder="Select Operation Cycle"
                                                                autoCompelete="off"
                                                                menuPlacement={'top'}
                                                                containerHeight="30px"
                                                                fontSize="93%"
                                                                isDisabled={this.state.enable_opc == 'N'}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Ax>
                                )}
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                disabled={this.state.saveFormSubmitting} 
                                className="btn btn-secondary" 
                                data-bs-dismiss="modal"
                                onClick={() => this.resetModalState()}
                            >
                                Close
                            </button>
                            {this.state.proceedForm ? (
                                <button 
                                    onClick={this.getAssetDetail} 
                                    disabled={this.state.saveFormSubmitting} 
                                    form={this.linkAssetModalFormId} 
                                    className="btn btn-primary mx-2"
                                >
                                    Proceed {this.state.saveFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            ) : (
                                <button 
                                    type="submit" 
                                    disabled={this.state.saveFormSubmitting} 
                                    form={this.linkAssetModalFormId} 
                                    className="btn btn-primary mx-2"
                                >
                                    {this.state.isBulkMode 
                                        ? (this.state.bulkActionType == "link" ? "Link All" : "Delink All")
                                        : (this.state.currentActionType == "link" ? "Link" : "Delink")
                                    } 
                                    {this.state.saveFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <CounterlogModal ref={this.CounterLogModalRef} afterSubmitCounterlog={(date, asset_id, refresh) => { this.afterUpdateCounterlogSubmit(date, asset_id, refresh) }} />
            </div>
        );
    }
    
    render = () => this.linkAssetModalJsx()
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(LinkingModal);